// imports section Start
import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  TextField,
  Button,
  Stack,
  Breadcrumbs,
  Link,
  AppBar,
} from "@mui/material";
import AddToolbar from "../../components/common/AddToolbar";

import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import {
  externalpostApi,
  externalgetApi,
} from "../../services/external/externalApis";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { SETTINGS_API_14 } from "../../api/ApiModel";
import dayjs from "dayjs";
import Slide from "@mui/material/Slide";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";
import { useSelector } from "react-redux";

// imports section End

const GiftCertificate = () => {
  // Hooks start
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [error1, setError1] = useState(null);
  const location = useLocation();
  const [errors, setErrors] = useState({});
  const { selectedItem } = location.state || {};
  const isEdit = location.state?.actionText === "Edit";
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    CERTIFICATECODE: "",
    REFERENCECODE: "",
    GIFTNAME: "",
    AMOUNT: "",
    EXPIRYDATE: "",
  });
  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, BUSINESSTYPECODE, USERNAME } =
    SYS_USER.USER_PARAM || {};

  // Handlers start

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Clear the error for the specific field when the user starts typing
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
    setSelectedItemDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function to handle date changes specifically
  const handleDateChange = (date, name) => {
    // Convert Dayjs object to the desired format or leave as Dayjs object if preferred
    const formattedDate = date ? date.format("YYYY-MM-DD") : "";
    if (errors[name] && formattedDate) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
    setSelectedItemDetails((prevState) => ({
      ...prevState,
      [name]: formattedDate,
    }));
  };

  const handleConfirmClick = async () => {
    const { GIFTNAME, EXPIRYDATE, AMOUNT } = selectedItemDetails;
    // Define required fields
    const requiredFields = [
      { name: "GIFTNAME", value: GIFTNAME, label: "Certificate Name" },
      { name: "EXPIRYDATE", value: EXPIRYDATE, label: "Validity Period" },
      { name: "AMOUNT", value: AMOUNT, label: "Amount" },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`; // Set error message for each missing field
      });

      setErrors(newError); // Set the error state
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Please Fill All the Required Fields.`;

      setSnackbarMessage(errorMessage); // Show snackbar with missing fields
      setOpenErrorSnackbar(true);
      return; // Stop submission if there are validation errors
    }
    // Continue with the rest of your function logic...

    if (data) {
      const isDuplicate = data.some((item) => {
        if (
          item.CERTIFICATECODE !== selectedItemDetails.CERTIFICATECODE &&
          item.GIFTNAME.toLowerCase().trim() === GIFTNAME.toLowerCase().trim()
        ) {
          return true;
        } else {
          return false;
        }
      });
      if (isDuplicate) {
        setSnackbarMessage("  Gift Certificate Name already exists.");
        setOpenErrorSnackbar(true);
        return; // Stop the function if a duplicate is found
      }
    }

    const staticValues = {
      COMPCODE,
      LOCCODE,
      BUSINESSTYPECODE: BUSINESSTYPECODE,
      MENUTYPECODE: CON_MENU_TYPE_CODE,
      STS: CON_STATUS_ACTIVE,

      REFERENCECODE: "",
      ENUSER: USERNAME,
      LOCDATE: new Date().toISOString(),
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SETTINGS_API_14, payload);
      console.log("Success:", responseData);
      setOpenSnackbar(true);
      setSelectedItemDetails({
        CERTIFICATECODE: "",

        GIFTNAME: "",
        AMOUNT: "",
        EXPIRYDATE: "",
      });
    } catch (error) {
      console.error("Error:", error);
    }

     setTimeout(() => {
      navigate("/vGiftcertificate");
    }, 2000);
  };

  const handleClearClick = () => {
    setSelectedItemDetails({
      GIFTNAME: "",
      AMOUNT: "",
      EXPIRYDATE: "",
    });
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false);
  };

  const handleInputValidation = (event) => {
    const { name, value } = event.target;

    // Allow only letters and spaces
    const regex = /^[a-zA-Z\s]*$/;
    if (regex.test(value)) {
      setError("");
      handleInputChange(event);
    } else {
      setError("Only letters and spaces are allowed.");
    }
  };

  const handlenumInputValidation = (event) => {
    const { name, value } = event.target;

    const regex = /^[0-9]*\.?[0-9]*$/;

    if (regex.test(value)) {
      setError1("");
      handleInputChange(event);
    } else {
      setError1("Only numbers and floats are allowed.");
    }
  };

  const gotToView = () => {
    navigate("/vGiftcertificate");
  };

  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        CERTIFICATECODE: String(selectedItem.CERTIFICATECODE),
        GIFTNAME: selectedItem.GIFTNAME,
        EXPIRYDATE: selectedItem.EXPIRYDATE,
        AMOUNT: String(selectedItem.AMOUNT),
      });
    }
  }, [selectedItem]);
  // Handlers end

  // API calls start
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTINGS_API_14, "get", {
          COMPCODE,

          BUSINESSTYPECODE,
          STS: CON_STATUS_ACTIVE,
        });
        setData(result);
      } catch (err) {
        setError(err);
      }
    };

    fetchData();
  }, []);
  // API calls end

  return (
    <div>
      <Navbar />

      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="hover">Home</Link>
                <Link underline="hover">Gift Certificates </Link>
                <Link underline="hover">{
          isEdit
              ? "Edit  Gift Certificates"
              : "Create  Gift Certificates"
          } </Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToView}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar
          label={{
            name: isEdit
              ? "Edit  Gift Certificate"
              : "Create  Gift Certificate",
          }}
        />
        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label="Certificate Name  "
              required
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="GIFTNAME"
              value={selectedItemDetails.GIFTNAME}
              onChange={handleInputChange}
              error={Boolean(errors.GIFTNAME)}
              helperText={errors.GIFTNAME}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label="Certificate Amount    "
              required
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="AMOUNT"
              value={selectedItemDetails.AMOUNT}
              onChange={handlenumInputValidation}
              error={Boolean(errors.AMOUNT)}
              helperText={errors.AMOUNT}
            />
          </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6}>
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DatePicker
      label={
        <span>
         Validity Period<span style={{ color: "red" }}> *</span>
        </span>
      }
      value={
        selectedItemDetails.EXPIRYDATE
          ? dayjs(selectedItemDetails.EXPIRYDATE)
          : null
      }
      minDate={dayjs()} // Disable dates before today
      onChange={(newValue) =>
        handleDateChange(newValue, "EXPIRYDATE")
      }
      slotProps={{
        textField: {
          error: Boolean(errors.EXPIRYDATE),
          helperText: errors.EXPIRYDATE,
          sx: {
            width: "100%",
            "& .MuiInputBase-root": {
              height: "40px",
              marginTop: "0.3rem",
            },
            "& .MuiInputAdornment-root .MuiIconButton-root": {
              color: theme.palette.text.secondary,
            },
          },
        },
        popper: {
          sx: {
            "& .MuiPaper-root": {
              backgroundColor: theme.palette.background.paper,
              boxShadow: "none",
            },
          },
        },
      }}
    />
  </LocalizationProvider>
</Grid>
        </Grid>
        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Stack>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {isEdit ? " Updated Successfully!" : " Created Successfully!"}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          message={snackbarMessage}
          autoHideDuration={6000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage || "Please fill out all fields before submitting."}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default GiftCertificate;
